import React, { useState, useEffect } from 'react';
import PlaceholderImage from "../resources/elementor-placeholder-image.webp";
import { doc, setDoc } from "firebase/firestore"; 
import { db, storage } from "../firebase/firebaseConfig";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from "firebase/firestore";

const CreateEvent = (e) => {
  const navigate = useNavigate();
  
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [featuredImage, setFeaturedImage] = useState(null); 
  const [reapeat, setReapeat] = useState("Do Not Repeat");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [eventType, setEventType] = useState("Free Event");
  const [publicType, setPublicType] = useState("");
  const [locationType, setLocationType] = useState("");
  const [location, setLocation] = useState("");
  const [registrationForm, setRegistrationForm] = useState("");
  const [placeholderImage, setPlacholderImage] = useState(PlaceholderImage);

  const generateId = () => {
    return [...Array(20)].map(() => Math.random().toString(36)[2]).join('');
  };

  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      const imageRef = storageRef(storage, `${generateId()}`);

      uploadBytes(imageRef, featuredImage)
        .then((snapshot) => {
          console.log("Image uploaded successfully");

          getDownloadURL(snapshot.ref)
            .then((url) => {
              console.log("Download URL: ", url);
              resolve(url); 
            })
            .catch((error) => {
              console.error("Error getting download URL: ", error);
              reject(error); 
            });
        })
        .catch((error) => {
          console.error("Error uploading image: ", error);
          reject(error); 
        });
    });
  };

  const createMyEvent = async (e) => {
    e.currentTarget.innerHTML = "Creating Event...";
    e.target.style.cursor = "wait";

    const id = generateId();

    const dateTimeStringStart = `${startDate}T${startTime}:00`; 
    const dateTimeStringEnd = `${endDate}T${endTime}:00`; 

    const dateTimeStart = new Date(dateTimeStringStart);
    const dateTimeEnd = new Date(dateTimeStringEnd);

    try {
      const imageUrl = await uploadImage();

      await setDoc(doc(db, "Events Calendar", id), {
        Title: title,
        Description: description,
        FeaturedImage: imageUrl,
        Repeat: reapeat,
        StartDateTime: dateTimeStart,
        EndDateTime: dateTimeEnd,
        EventType: eventType,
        PublicRegistration: publicType,
        LocationType: locationType,
        Location: location,
        RegistrationForm: registrationForm
      });

      console.log("Event successfully created!");

    } catch (error) {
      console.error("Error creating event: ", error);
    }

    navigate('/events-calendar');
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setPlacholderImage(URL.createObjectURL(file));
    setFeaturedImage(file);
  };
  
  const [formsData, setFormsData] = useState([]);

  useEffect(() => {
    const fetchFormsData = async () => {
        try {
        const querySnapshot = await getDocs(collection(db, "Forms"));
        const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setFormsData(documents);
        console.log(documents)
        } catch (error) {
        console.error("Error fetching data: ", error);
        }
    };
  
    fetchFormsData();
  }, []);

  return (
    <div id='content'>
      <h1>Create Event</h1>
        <div className='row'>
          <div className='col-sm-8'>
            <div className='ev-basic-info'>
              <h4>Basic Info</h4>
              <label>Event Title
              <br/> <input type="text" onChange={(e) => setTitle(e.target.value)}/></label>
              <label>Event Description
              <br/> <textarea onChange={(e) => setDescription(e.target.value)}/></label>
              <label className='checkbox-label'><input type="checkbox" onChange={(e) => setPublicType(e.target.value)}/> Public Registration</label>
              <select onChange={(e) => setEventType(e.target.value)}>
                <option value="Free Event">Free Event</option>
                <option value="Paid Event">Paid Event</option>
              </select>
            </div>
            <br/>
            <h4>Date & Time</h4>
            <div className='row'>
              <div className='col-sm-3'>
                <label>Start Date
                <br/> <input type="date" onChange={(e) => setStartDate(e.target.value)}/></label>
              </div>
              <div className='col-sm-3'>
                <label>Start Time
                <br/> <input type="time" onChange={(e) => setStartTime(e.target.value)}/></label>
              </div>
              <div className='col-sm-3'>
                <label>End Date
                <br/> <input type="date" onChange={(e) => setEndDate(e.target.value)}/></label>
              </div>
              <div className='col-sm-3'>
                <label>End Time
                <br/> <input type="time" onChange={(e) => setEndTime(e.target.value)}/></label>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-3'>
              </div>
              <div className='col-sm-3'>
              </div>
              <div className='col-sm-3'>
              </div>
              <div className='col-sm-3'>
                <select onChange={(e) => setReapeat(e.target.value)}>
                  <option value="Do Not Repeat">Do Not Repeat</option>
                  <option value="Repeat Every Week">Repeat Every Week</option>
                  <option value="Repeat Every Day">Repeat Every Day</option>
                </select>
              </div>
            </div>
            <br/>
            <h4>Location</h4>
            <label className='checkbox-label'><input type="checkbox" onChange={(e) => setLocationType(e.target.value)}/> Online Event</label>
            <label>Address/Online Link <input type="text" onChange={(e) => setLocation(e.target.value)}/></label>
          </div>
          <div className='col-sm-4' style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <div>
              <img src={placeholderImage} width="95%"/>
              <label style={{ cursor: 'pointer' }}  htmlFor="file-upload" className="custom-file-upload">
                <b>Change Featured Image</b>
              </label>
              <input
                id="file-upload"
                type="file"
                onChange={handleImageChange}
                style={{ display: 'none' }} 
              />
            <br/>
            <br/>
              <h4>Registration</h4>
              <label>Register Form</label>
              <select onChange={(e) => setRegistrationForm(e.target.value)}>
                <option value="None">None</option>
                {formsData.map((item, index) => (
                  <option key={index} value={item.Title}>{item.Title}</option>
                ))}
              </select>
            </div>
            <br/>
            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
              <button onClick={(e) => createMyEvent(e)}>Create Event</button>
            </div>
          </div>
        </div>
    </div>
  );
}

export default CreateEvent;
